import { useEffect, useState } from "react";
import { Tooltip } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import styled from "styled-components";

import { InputErrorIcon } from "../../../../packages/SVGs";

import { colors, fontStyles } from "../../Theme";

import { combineClassNames } from "../../../../utils/appUtils";

const StyledTooltip = styled(Tooltip)`
  padding-left: ${({ type }) => (type === "error" ? "0 !important" : "auto")};

  .error {
    svg {
      padding-right: 5px !important;
      path {
        fill: white !important;
      }
    }
  }

  .tooltip-inner {
    max-width: ${({ maxWidth }) => maxWidth};
    background-color: ${({ type }) =>
      type === "error" ? "var(--du-color-red)" : colors.DefaultBackground};
    text-align: left;
    ${fontStyles.diodrum12}
    color: ${colors.White};

    ${({ type }) =>
      type === "error" &&
      `
        svg {
          margin-right: 5px !important;
              margin-bottom: 2px;
          path {
            fill: white !important;
            stroke: 1.5;
          }
        }
      `}
  }

  .tooltip-arrow::before {
    border-top-color: ${({ type }) =>
      type === "error"
        ? "var(--du-color-red)"
        : colors.DefaultBackground} !important;
  }
`;

const StyledOverlayTrigger = styled(OverlayTrigger)`
  border-radius: 2px;
  text-align: left;
`;

const CustomTooltip = ({
  text,
  children,
  type,
  className,
  placement = "top",
  forceShow = false,
  maxWidth = "200px",
}) => {
  const [show, setShow] = useState(true);
  const hasTooltipText = Boolean(text);
  const shouldForceShow = forceShow && hasTooltipText;

  const renderTooltip = (isError) => (
    <StyledTooltip
      id="tooltip"
      type={type}
      className={combineClassNames("error", className)}
      maxWidth={maxWidth}
    >
      {isError && <InputErrorIcon />}
      {text}
    </StyledTooltip>
  );

  useEffect(() => setShow(hasTooltipText), [hasTooltipText]);

  // Keep OverlayTrigger mounted even when tooltip text disappears
  // so wrapped inputs do not remount and lose focus while overflow changes during typing.
  // refer to PR for more details on why we keep OverlayTrigger mounted in all cases.
  return type === "error" ? (
    <StyledOverlayTrigger
      show={hasTooltipText ? (shouldForceShow ? true : show) : false}
      // Use the default OverlayTrigger behavior when there is tooltip text, so passing undefined,
      // and disable all triggers([]) when there is nothing to display.
      trigger={hasTooltipText ? undefined : []}
      placement="top-start"
      overlay={renderTooltip(true)}
      className="width-auto"
    >
      {children}
    </StyledOverlayTrigger>
  ) : (
    <StyledOverlayTrigger
      show={hasTooltipText ? (shouldForceShow ? true : undefined) : false}
      // Use the default OverlayTrigger behavior when there is tooltip text, so passing undefined,
      // and disable all triggers([]) when there is nothing to display.
      trigger={hasTooltipText ? undefined : []}
      placement={placement}
      overlay={renderTooltip()}
    >
      {children}
    </StyledOverlayTrigger>
  );
};

export default CustomTooltip;
